import React from 'react';
import axios from 'axios';
import { Button, Select, DatePicker, message, Form, Space, Typography, Empty } from 'antd';
import { SearchOutlined, CalendarOutlined } from '@ant-design/icons';
import * as serverconfig from '../../serverconn';
import SportsMotorsportsIcon from '@mui/icons-material/SportsMotorsports';
import PolylineMap_Activities from '../components/PolylineMap_Activities';
import ProfessionalLayout from '../../../components/ProfessionalLayout';

const { Option } = Select;
const { Text } = Typography;
const dateFormat = 'DD/MM/YYYY';

let token = '';

class AgentActivityMap extends React.Component {
  state = {
    datarequested: true,
    day_activities: [],
    selected_account: '',
    date: '',
    delivery_agents: [],
    searchingActivities: false
  };

  componentDidMount() {
    this.initializeAuth();
    this.loadDeliveryAgents();
  }

  initializeAuth = () => {
    if (localStorage.getItem("token")) {
      token = localStorage.getItem("token");
    }

    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${token}`
    };
  }

  loadDeliveryAgents = () => {
    axios.get(`${serverconfig.backendserverurl}/api/delivery_agents/`)
      .then(res => {
        this.setState({
          delivery_agents: res.data,
          datarequested: false
        });
      })
      .catch(error => {
        console.error('Error loading agents:', error);
        this.setState({ datarequested: false });
      });
  }

  handleSearch = () => {
    const { date, selected_account } = this.state;

    if (!date) {
      message.error("Please select a date");
      return;
    }
    
    if (!selected_account) {
      message.error("Please select an agent");
      return;
    }

    this.setState({ searchingActivities: true, day_activities: [] });

    const form_data = new FormData();
    form_data.append('date', date);
    form_data.append('selected_acccount', selected_account);

    axios.post(`${serverconfig.backendserverurl}/customqueries/getagent_dayactivities`, form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
    .then(res => {
      this.setState({
        searchingActivities: false,
        day_activities: JSON.parse(res.data.report)
      });
    })
    .catch(error => {
      console.error('Error fetching activities:', error);
      message.error('Failed to load agent activities');
      this.setState({ searchingActivities: false });
    });
  }

  render() {
    const { 
      datarequested, 
      day_activities, 
      selected_account, 
      date, 
      delivery_agents,
      searchingActivities 
    } = this.state;

    const searchForm = (
      <div className="professional-form">
        <Form layout="vertical">
          <Space size="large" wrap>
            <Form.Item label="Select Agent" style={{ minWidth: 250 }}>
              <Select
                placeholder="Choose delivery agent"
                value={selected_account}
                onChange={(val) => this.setState({ selected_account: val })}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
              >
                {delivery_agents.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.FullName} | {item.RegisteredPhoneNumber1} | {item.agent_code}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Select Date" style={{ minWidth: 200 }}>
              <DatePicker
                placeholder="Choose date"
                onChange={(date, dateString) => {
                  this.setState({ date: dateString });
                }}
                format={dateFormat}
                style={{ width: '100%' }}
                suffixIcon={<CalendarOutlined />}
              />
            </Form.Item>

            <Form.Item label=" " style={{ minWidth: 120 }}>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={this.handleSearch}
                loading={searchingActivities}
                className="professional-button professional-button-primary"
                size="large"
              >
                Search Activities
              </Button>
            </Form.Item>
          </Space>
        </Form>
      </div>
    );

    const selectedAgent = delivery_agents.find(agent => agent.id === selected_account);
    const subtitle = selectedAgent 
      ? `Activity tracking for ${selectedAgent.FullName} (${selectedAgent.agent_code})`
      : "Track agent movement patterns and daily activities";

    return (
      <ProfessionalLayout
        title="Agent Activity Tracker"
        subtitle={subtitle}
        icon={<SportsMotorsportsIcon />}
        loading={datarequested}
      >
        {!datarequested && (
          <>
            {searchForm}
            
            {searchingActivities ? (
              <div style={{ textAlign: 'center', padding: '60px 0' }}>
                <Text type="secondary">Loading agent activities...</Text>
              </div>
            ) : day_activities.length > 0 ? (
              <div className="professional-map-container">
                <PolylineMap_Activities initialCoordinates={day_activities} />
                <div style={{ marginTop: 16, padding: 16, background: '#f0f2f5', borderRadius: 8 }}>
                  <Text strong>Activity Summary: </Text>
                  <Text>{day_activities.length} activity points recorded for {date}</Text>
                </div>
              </div>
            ) : (selected_account && date) ? (
              <div className="professional-empty-state">
                <Empty
                  description={
                    <div>
                      <Text type="secondary" style={{ fontSize: 16 }}>
                        No activities found for the selected date
                      </Text>
                      <br />
                      <Text type="secondary" style={{ fontSize: 14 }}>
                        Try selecting a different date or agent
                      </Text>
                    </div>
                  }
                  imageStyle={{ height: 80 }}
                />
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <Text type="secondary" style={{ fontSize: 16 }}>
                  Select an agent and date to view their activity tracking
                </Text>
              </div>
            )}
          </>
        )}
      </ProfessionalLayout>
    );
  }
}

export default AgentActivityMap; 
